export enum SubscriptionType {
  STARTER = 'STARTER',
  STANDARD = 'STANDARD',
  PREMIUM = 'PREMIUM',
  BASIC = 'BASIC',
  PROFESSIONAL = 'PROFESSIONAL',
  UNLIM = 'UNLIM'
}
